module.exports = __webpack_public_path__ + "static/media/landelijk.1443afe3.jpg";